import React, { useEffect, useState } from 'react'

const useIsMounted = () => {
    const [isMounted, setIsMounted] = useState(false)


    useEffect(() => {
        setIsMounted(true)
    }, [])

    return isMounted
}

export default useIsMounted